import { gql } from "@apollo/client";

export const PERSON_WORKPLACES_UPDATED = gql`
  subscription personWorkplacesUpdated {
    personWorkplacesUpdated {
      partnerId
    }
  }
`;
